import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { mockPRs } from '../data/mockData';
import { NOAPanel } from '../components/procurement/NOAPanel';
import { StatusBadge } from '../components/StatusBadge';
export function NOAAction() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const pr = mockPRs.find(p => p.id === id);
  if (!pr) {
    return <div className="flex flex-col items-center justify-center h-full" data-id="element-1390">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-1391">PR not found</h2>
        <button onClick={() => navigate('/noa')} className="mt-4 text-indigo-600 hover:text-indigo-800" data-id="element-1392">
          Back to NOA List
        </button>
      </div>;
  }
  const referenceType = pr.procurementMethod === 'Short Purchase' ? 'RFQ' : 'RFP';
  return <div className="max-w-6xl mx-auto space-y-6 pb-12" data-id="element-1393">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-1394">
        <div className="flex items-center space-x-4" data-id="element-1395">
          <button onClick={() => navigate('/noa')} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-1396">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-1397" />
          </button>
          <div data-id="element-1398">
            <div className="flex items-center space-x-3" data-id="element-1399">
              <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-1400">
                Process NOA
              </h1>
              <StatusBadge status="Draft" data-id="element-1401" />
            </div>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1402">
              Notice of Award for {pr.prNo}
            </p>
          </div>
        </div>
      </div>

      {/* PR Context Card */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-wrap gap-6" data-id="element-1403">
        <div data-id="element-1404">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1405">
            PR Number
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-1406">{pr.prNo}</p>
        </div>
        <div data-id="element-1407">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1408">
            Originator
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-1409">
            {pr.originator}
          </p>
        </div>
        <div data-id="element-1410">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1411">
            Method
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-1412">
            {pr.procurementMethod}
          </p>
        </div>
        <div data-id="element-1413">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1414">
            Total Amount
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-1415">
            ${pr.total.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Embedded Panel */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-1416">
        <NOAPanel referenceType={referenceType} data-id="element-1417" />
      </div>
    </div>;
}